import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../../hooks/useSEO';

export default function TaoyuanAreaPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🎯 Local SEO Optimization - 強化長尾關鍵字
  useSEO({
    title: '桃園搬家公司推薦2025｜桃園中壢平鎮搬家費用價格｜桃園搬家多少錢｜跨縣市搬家 0978-900-081',
    description: '桃園搬家公司推薦首選！建鈞精緻搬家服務桃園市13區（桃園區、中壢區、平鎮區、八德區、楊梅區、蘆竹區、龜山區等），提供套房搬家3000元起、家庭搬遷、辦公室搬遷、跨縣市搬家。專業團隊，4.8分高評價156則好評，透明收費無隱藏費用，工業區搬遷經驗豐富。免費估價：0978-900-081',
    keywords: '桃園搬家,桃園市搬家公司,桃園搬家推薦,桃園搬家費用,桃園搬家價格,中壢搬家,平鎮搬家,八德搬家,楊梅搬家,蘆竹搬家,龜山搬家,桃園搬家公司推薦,桃園專業搬家,桃園搬家多少錢,桃園搬家推薦ptt,桃園學生搬家,桃園套房搬家,桃園工業區搬家,跨縣市搬家,桃園到台北搬家,桃園搬家評價,桃園24小時搬家,中壢搬家公司',
    ogType: 'website',
    ogImage: 'https://public.readdy.ai/ai/img_res/47d1ed8908982d80b9f2c80f7c9fa9da.jpg'
  });

  // 🎯 Schema.org LocalBusiness Structured Data
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "建鈞精緻搬家 - 桃園市搬家服務",
      "image": "https://readdy.ai/api/search-image?query=Taoyuan%20city%20landscape%20with%20modern%20residential%20buildings%20and%20urban%20development%2C%20clear%20blue%20sky%20with%20organized%20neighborhoods%2C%20professional%20moving%20services%20concept&width=1200&height=630&seq=taoyuan-schema&orientation=landscape",
      "@id": "https://www.example.com/area/taoyuan",
      "url": "https://www.example.com/area/taoyuan",
      "telephone": "0978-900-081",
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "桃園市",
        "addressRegion": "桃園市",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 24.9936,
        "longitude": 121.3010
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [
        "https://line.me/ti/p/@285yavdh"
      ],
      "areaServed": [
        "桃園區", "中壢區", "平鎮區", "八德區", "楊梅區", "蘆竹區", 
        "龜山區", "龍潭區", "大溪區", "大園區", "新屋區", "觀音區", "復興區"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "156"
      }
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const districts = [
    { name: '桃園區', features: '市政府所在地，商業住宅混合', tips: '市區交通繁忙，建議避開尖峰時段', popular: true },
    { name: '中壢區', features: '工業區與住宅區並存，人口密集', tips: '工業區搬遷需提前規劃路線', popular: true },
    { name: '平鎮區', features: '工業園區多，新興住宅區發展快', tips: '注意工業區車輛管制時間', popular: true },
    { name: '八德區', features: '近年發展迅速，新建社區多', tips: '新社區管理嚴格，需提前申請' },
    { name: '楊梅區', features: '工業區與農業區並存', tips: '部分區域道路狹窄，需小型車輛' },
    { name: '蘆竹區', features: '近機場，物流業發達', tips: '機場周邊交通管制需注意' },
    { name: '龜山區', features: '工業區林立，近台北', tips: '上下班時段塞車嚴重' },
    { name: '龍潭區', features: '科學園區，山區地形', tips: '山路崎嶇，搬運時間較長' },
    { name: '大溪區', features: '觀光老街，透天厝多', tips: '老街區巷弄狹窄，需注意' },
    { name: '大園區', features: '近機場，農業區為主', tips: '距離市區較遠，運輸時間長' },
    { name: '新屋區', features: '沿海地區，透天厝多', tips: '海風強勁，搬運需注意固定' },
    { name: '觀音區', features: '工業區與農業區', tips: '工業區搬遷需配合廠區規定' }
  ];

  const services = [
    { icon: 'ri-home-4-line', title: '套房搬遷', desc: '學生、上班族租屋搬家' },
    { icon: 'ri-building-line', title: '家庭搬遷', desc: '透天厝、公寓住家搬遷' },
    { icon: 'ri-briefcase-line', title: '辦公室搬遷', desc: '企業、工廠搬遷服務' },
    { icon: 'ri-truck-line', title: '跨縣市搬家', desc: '長途搬家專業服務' }
  ];

  const faqs = [
    {
      question: '桃園搬家公司推薦哪一家？中壢平鎮哪家好？',
      answer: '建鈞精緻搬家服務桃園市 13 個行政區，4.8 分高評價，156 則客戶好評，提供 24 小時免費估價。我們熟悉桃園各區道路和交通特性，從市區到山區都有豐富的搬家經驗。桃園區、中壢區、平鎮區是我們服務最頻繁的區域，工業區搬遷經驗特別豐富，累積超過 500 件成功案例。'
    },
    {
      question: '桃園搬家費用怎麼算？2025年價格多少？',
      answer: '2025年桃園搬家費用：套房搬遷 3,000 元起（雙邊電梯優惠價），兩房家庭搬家 6,000-8,000 元，三房搬家 10,000-15,000 元，辦公室搬遷依規模現場估價。跨縣市搬家（如桃園到台北）另計距離費，約 15,000-25,000 元。工業區設備搬遷需現場評估。我們提供免費現場估價，確保報價透明準確。'
    },
    {
      question: '桃園搬家當天可以預約嗎？急件怎麼辦？',
      answer: '建議提前 3-7 天預約，讓我們有充足時間安排專業團隊。旺季（週末、月底、6-8月）建議提前 2 週預約。如有急件需求（當天或隔天搬家），可來電 0978-900-081 詢問當天是否有空檔。桃園市區、中壢、平鎮等熱門區域建議提早預約，確保最佳搬家時段。'
    },
    {
      question: '桃園到台北搬家需要多久時間？費用多少？',
      answer: '桃園到台北約 40-50 公里，車程約 1-1.5 小時（依交通狀況）。一般兩房家庭搬家含打包、搬運、定位，全程約需 5-7 小時。費用約 15,000-20,000 元（含基本搬運費 + 距離費 + 樓層費）。三房搬家約 20,000-30,000 元。我們會根據交通狀況和搬家規模，提供準確的時間估算和報價。'
    },
    {
      question: '桃園工業區搬遷有什麼注意事項？',
      answer: '工業區搬遷需注意：1. 提前向廠區申請搬運許可（通常需 3-7 天）；2. 確認車輛進出時間限制（避開上下班尖峰）；3. 精密設備需特殊包裝和防震措施；4. 遵守廠區安全規定（安全帽、反光背心等）；5. 大型機械設備可能需吊車協助。我們有豐富的工業區搬遷經驗，熟悉中壢、平鎮、龜山等工業區環境，能妥善處理各種設備搬運。'
    },
    {
      question: '桃園搬家什麼時間最便宜？學生搬家有優惠嗎？',
      answer: '平日（週一至週五）和非月底時段價格較優惠，可省 10-20%。避開搬家旺季（6-8月、12月）和週末，可享有更好的價格。學生搬家我們提供優惠方案，套房搬遷 2,500 元起，提供學生證可享額外折扣。我們也提供夜間搬家服務，配合您的時間需求，歡迎來電詢問優惠方案。'
    },
    {
      question: '桃園龍潭、大溪、復興山區搬家會加價嗎？',
      answer: '龍潭、大溪、復興等山區因路況較複雜、距離較遠，會酌收距離費和山區搬運費。龍潭科學園區因山路崎嶇，搬運時間較長；大溪老街區巷弄狹窄，需使用小型車輛；復興山區道路蜿蜒，需要經驗豐富的師傅。實際費用依起點和終點位置而定，建議先預約免費現場估價，我們會提供最合理的報價。'
    },
    {
      question: '桃園機場周邊搬家方便嗎？蘆竹大園怎麼搬？',
      answer: '桃園機場周邊（蘆竹、大園）搬家需注意機場交通管制和航道限制。蘆竹區近年發展快速，新建社區多，電梯設備完善，搬家相對便利。大園區距離市區較遠，運輸時間較長，但道路寬敞，大型車輛通行方便。我們熟悉機場周邊環境，會提前規劃最佳路線，確保搬家順利進行。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Taoyuan%20city%20landscape%20with%20modern%20residential%20buildings%20and%20urban%20development%2C%20clear%20blue%20sky%20with%20organized%20neighborhoods%20and%20green%20spaces%2C%20professional%20moving%20services%20concept%20with%20vibrant%20cityscape&width=1920&height=500&seq=taoyuan001&orientation=landscape"
            alt="桃園市搬家服務"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold mb-6">桃園市搬家服務</h1>
          <p className="text-xl mb-8 leading-relaxed">
            服務桃園市13個行政區，從市區到山區<br />
            提供最專業、最貼心的桃園搬家服務
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081" 
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              立即致電：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>

      {/* 桃園市各區搬家特性 */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">桃園市各區搬家指南</h2>
            <p className="text-xl text-gray-600">了解各區特性，提供最適合的搬家方案</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {districts.map((district, index) => (
              <div 
                key={index} 
                className={`bg-gradient-to-br ${district.popular ? 'from-teal-50 to-white border-teal-200' : 'from-gray-50 to-white border-gray-200'} p-6 rounded-xl border hover:shadow-lg transition-shadow cursor-pointer`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-12 h-12 ${district.popular ? 'bg-teal-500' : 'bg-gray-600'} rounded-lg flex items-center justify-center`}>
                    <i className="ri-map-pin-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">{district.name}</h3>
                    {district.popular && (
                      <span className="text-xs bg-teal-500 text-white px-2 py-1 rounded-full">熱門區域</span>
                    )}
                  </div>
                </div>
                <div className="space-y-3">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">區域特色</p>
                    <p className="text-gray-700">{district.features}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">搬家建議</p>
                    <p className="text-teal-600 font-medium">{district.tips}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 桃園搬家服務項目 */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">桃園搬家服務項目</h2>
            <p className="text-xl text-gray-600">全方位搬家解決方案，滿足各種需求</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 桃園搬家常見問題 */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-50 to-emerald-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">桃園搬家常見問題</h2>
            <p className="text-xl text-gray-600">最多桃園客戶詢問的搬家問題</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all">
                <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-start gap-3">
                  <i className="ri-question-line text-teal-600 text-2xl flex-shrink-0"></i>
                  <span>{faq.question}</span>
                </h3>
                <p className="text-gray-700 leading-relaxed pl-11">{faq.answer}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link 
              to="/faq"
              className="inline-block bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多常見問題
            </Link>
          </div>
        </div>
      </section>

      {/* 桃園搬家價格參考 */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">桃園搬家價格參考</h2>
            <p className="text-xl text-gray-600">透明收費，絕無隱藏費用</p>
          </div>

          <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-teal-500 to-teal-600 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left font-semibold">搬家類型</th>
                    <th className="px-6 py-4 text-left font-semibold">坪數/規模</th>
                    <th className="px-6 py-4 text-left font-semibold">參考價格</th>
                    <th className="px-6 py-4 text-left font-semibold">備註</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">套房搬遷</td>
                    <td className="px-6 py-4 text-gray-700">5-10坪</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">$3,000起</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">含基本搬運</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">兩房搬遷</td>
                    <td className="px-6 py-4 text-gray-700">15-25坪</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">$6,000起</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">含家具拆裝</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">三房搬遷</td>
                    <td className="px-6 py-4 text-gray-700">30-40坪</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">$10,000起</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">含打包服務</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">跨縣市搬家</td>
                    <td className="px-6 py-4 text-gray-700">依距離</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">現場估價</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">另計距離費</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">辦公室搬遷</td>
                    <td className="px-6 py-4 text-gray-700">依規模</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">現場估價</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">含設備搬運</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                <i className="ri-information-line text-teal-500 mr-2"></i>
                以上價格為參考價格，實際費用依現場評估為準。樓層費、距離費、特殊物品另計。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-500 to-teal-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">需要桃園搬家服務？</h2>
          <p className="text-xl mb-8 leading-relaxed">
            服務桃園市13個行政區，熟悉各區道路和交通特性<br />
            專業團隊、透明收費、服務貼心
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081"
              className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              電話諮詢：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-teal-700 hover:bg-teal-800 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
